module.exports = __webpack_public_path__ + "Roboto-Light-webfont.a990f611f2305dc12965.eot";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Light-webfont.eot
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Light-webfont.eot
// module chunks = 2